import { render, staticRenderFns } from "./family_members_canada.vue?vue&type=template&id=1fc1faee&"
import script from "./family_members_canada.vue?vue&type=script&lang=js&"
export * from "./family_members_canada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports